<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
                <slot name="buttons"></slot>
            </div>
            <div class="align-self-end">
                <input-debounced
                    v-model="search"
                    :clearable="true"
                    :autofocus="true"
                    placeholder="Search"
                    class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
            :base-url="urlWithFilters"
            ref="baseTable"
            @load-success="onLoadSuccess"
            @refresh="onRefresh"
            :current-page="currentPage"
            v-loading="isRefreshing"
            element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                    :data="items"
                    stripe
                    class="w-100"
                >
                    <el-table-column
                        prop="model.id"
                        label="Id"
                        min-width="40"
                    ></el-table-column>
                    <el-table-column
                        prop="model.brand"
                        label="Brand name"
                        min-width="300"
                        :formatter="formatBrand"
                    ></el-table-column>
                    <el-table-column
                        prop="model.contact"
                        label="Contact"
                        min-width="300"
                        :formatter="formatContact"
                    ></el-table-column>
                    <el-table-column
                        prop="model.user"
                        label="User"
                        min-width="300"
                        :formatter="formatUser"
                    ></el-table-column>
                    <el-table-column
                        prop="model.begin_at"
                        label="Begin"
                        min-width="120"
                        :formatter="formatDate"
                    ></el-table-column>
                    <el-table-column
                            prop="model.end_at"
                            label="End"
                            min-width="120"
                            :formatter="formatDate"
                    ></el-table-column>
                    <el-table-column
                        label="Actions"
                        v-slot="{row}"
                    >
                        <actions-column :row="row" @edit="onEdit" @delete="onDelete"></actions-column>
                    </el-table-column>
                </el-table>
            </template>
        </base-table>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import ActionsColumn from './actions-column';
  import {addQueryParams} from '../../libs/url';

  export default {
    extends: TableWithPagination,

    components: {
      ActionsColumn
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },
    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },
    watch: {
      search: function (value) {
        if (value) {
          this.filters = _.assign({}, this.filters, {search: value});
        } else {
          this.filters = _.omit(this.filters, ['search']);
        }
      },
    },
    methods: {
      /**
       * @param {object} row
       * @param {object} col
       * @param {object} value
       */
      formatBrand(row, col, value) {
        return _.get(value, 'title');
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {object} value
       */
      formatContact(row, col, {full_name = '', phone_number = ''}) {
        return `${full_name} (${phone_number})`;
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {object} value
       */
      formatUser(row, col, {full_name = ''}) {
        return `${full_name}`;
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {string} datetime
       */
      formatDate(row, col, {datetime}) {
        return moment(datetime).format(config('format.moment.short.datetime'));
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {string} url
       * @event show-add-contact-hold-dialog
       */
      onEdit({url}) {
        eventBus.$emit('show-add-contact-hold-dialog', url);
      },

      /**
       * @param {string} url
       */
      onDelete({url}) {
        axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          });
      }
    }
  }
</script>
